import {
  isPasskeyCredentialJsonInput,
  normalizePublicKeyCredentialJson,
  type PasskeyCredentialJsonInput,
  serializePublicKeyCredential,
} from '@modules/passkey/helpers/webauthn-serializer.helper';

const getCredentialJsonPayload = (credential: PublicKeyCredential): PasskeyCredentialJsonInput => {
  if ('toJSON' in credential && typeof credential.toJSON === 'function') {
    const json: unknown = credential.toJSON();

    if (isPasskeyCredentialJsonInput(json)) {
      return json;
    }

    return serializePublicKeyCredential(credential);
  }

  return serializePublicKeyCredential(credential);
};

export const toCredentialJson = (credential: PublicKeyCredential): string =>
  JSON.stringify(normalizePublicKeyCredentialJson(getCredentialJsonPayload(credential)));
